class ChatModel {
  chat: ChatRequestMessageModel[];
  createDate: string;
  id: string;
  modifyDate: string;
  obsolete: boolean;
  serviceProviderId: string;
  serviceProviderModel: string;
  serviceProviderState: number;
  state: number;
  userIdParty: string;
  userLanguage: any;

  constructor(model: any) {
    this.chat = [];
    model.chat.forEach(chat => {
      if (chat.role !== 0 && chat.role !== 3) //System and Function
        this.chat.push(new ChatRequestMessageModel(chat));
    });

    this.createDate = model.createDate;
    this.id = model.id;
    this.modifyDate = model.modifyDate;
    this.obsolete = model.obsolete;
    this.serviceProviderId = model.serviceProviderId;
    this.serviceProviderModel = model.serviceProviderModel;
    this.serviceProviderState = model.serviceProviderState;
    this.state = model.state;
    this.userIdParty = model.userIdParty;
    this.userLanguage = model.userLanguage;
  }
}

class ChatRequestMessageModel {
  role: number;
  content: string;

  constructor(model: any) {
    this.role = model.role;
    this.content = model.content;
  }
}

export { ChatModel, ChatRequestMessageModel };
